import { useContext, useEffect, useState } from "react";
import { Box, Collapse, IconButton, Table, Switch, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Stack } from "@mui/material";
import MaterialAction from "./MaterialAction";
import ListMaterialUnit from "./ListMaterialUnit";
import LoadingPage from "../Include/LoadingPage";
import EmptyData from "../Include/EmptyData";
import { Fragment } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import ListMaterialUnitAction from "./ListMaterialUnitAction";
import { UPDATE_LIST_MATERIAL_UNIT_IS_USE } from "../../Schema/ListMaterialUnit";
import { useMutation } from "@apollo/client";
import { AuthContext } from "../../Context/AuthContext";
import ViewMeterialUnit from "./ViewMeterialUnit";


export default function TableViewListAllItem({
  loading,
  tableData,
  paginationData,
  refetch,
}) {

  const { setAlert } = useContext(AuthContext);
  const [dataView, setDataView] = useState([])

  //=============== Hook Open Dialog View ============
  const [openView, setOpenView] = useState();
  const handleOpenView = () => {
    setOpenView(true);
  }
  const handleCloseView = () => {
    setOpenView(false);
  }

  const [updateListMaterialUnitIsUse] = useMutation(UPDATE_LIST_MATERIAL_UNIT_IS_USE,
    {
      onCompleted: ({ updateListMaterialUnitIsUse }) => {
        // console.log("updateListMaterialUnitIsUse", updateListMaterialUnitIsUse);
        if (updateListMaterialUnitIsUse?.status) {
          setAlert(true, "success", updateListMaterialUnitIsUse?.message);
        } else {
          setAlert(true, "error", updateListMaterialUnitIsUse?.message);
        }
      },
      onError: (error) => {
        setAlert(true, "error", error?.message);
      },
    }
  );

  const handleUpdateStatus = (id, isUse) => {
    updateListMaterialUnitIsUse({
      variables: {
        id,
        isUse,
      },
      onCompleted: () => {
        refetch();
      },
    });
  };

  const handleViewItemData = (data) => {
    handleOpenView();
    setDataView([data])
  }

  //================= width Modify ===============
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => setWidth(window.innerWidth - 50);

  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);



  return (
    <Box className="body-container">
      <TableContainer sx={{ maxWidth: `${width}px` }}>
        <Table className="table" aria-label="simple table" size="small">
          <TableHead className="header-row">
            <TableRow>
              {/* <TableCell className="header-title-start" width="3%" /> */}
              <TableCell className="header-title-start" width="3%">
                ល.រ
              </TableCell>
              <TableCell className="header-title" width="20%">
                ឈ្មោភាសាខ្មែរ
              </TableCell>
              <TableCell className="header-title" width="8%">
                ឯកតា
              </TableCell>
              <TableCell className="header-title" width="8%" align="center">
                ទំហំ
              </TableCell>
              <TableCell className="header-title" width="10%" align="center">
                តម្លៃរាយ
              </TableCell>
              <TableCell className="header-title" width="15%">
                ប្រភេទ
              </TableCell>
              <TableCell className="header-title" >
                ចំណាំ
              </TableCell>
              <TableCell className="header-title" width="7%" align="right">
                ស្ថានភាព
              </TableCell>
              <TableCell className="header-title-end" width="10%"></TableCell>
            </TableRow>
          </TableHead>
          {loading ? (
            <TableBody className="body">
              <TableRow className="body-row">
                <TableCell colSpan={12} className="body-cell">
                  <LoadingPage />
                </TableCell>
              </TableRow>
            </TableBody>
          ) : (
            <>
              {tableData?.length === 0 ? (
                <TableBody className="body">
                  <TableRow className="body-row">
                    <TableCell colSpan={12} className="body-cell">
                      <EmptyData />
                    </TableCell>
                  </TableRow>
                </TableBody>
              ) : (
                <TableBody className="body">
                  {tableData?.map((row, index) => (
                    <Fragment key={index}>
                      <TableRow className="body-row">

                        {/* <TableCell className="body-cell"> */}
                          {/* <IconButton
                                aria-label="expand row"
                                size="small"
                                onClick={() => handleViewItemData(index)}
                              >
                                {expandedRows[index] ? (
                                  <KeyboardArrowUpIcon
                                    sx={{ color: "#00A0DC" }}
                                  />
                                ) : (
                                  <KeyboardArrowDownIcon
                                    sx={{ color: "#00A0DC" }}
                                  />
                                )}
                              </IconButton> */}
                        {/* </TableCell> */}

                        <TableCell className="body-cell-start">
                          {index + paginationData?.slNo}
                        </TableCell>

                        <TableCell
                          className="body-cell"
                          onClick={() => handleViewItemData(row)}
                        >
                          {row?.materialId?.materialKhName}
                        </TableCell>

                        <TableCell
                          className="body-cell"
                          onClick={() => handleViewItemData(row)}
                        >
                          {row?.unitId?.unitKhName}
                        </TableCell>

                        <TableCell
                          className="body-cell"
                          align="center"
                          onClick={() => handleViewItemData(row)}
                        >
                          {row?.materialId?.sizeId?.sizeKhName}
                        </TableCell>
                        <TableCell
                          className="body-cell"
                          onClick={() => handleViewItemData(row)}
                        >
                          <Stack direction="row" justifyContent="center">
                            <Stack direction="row" spacing={1} width="50%">
                              <Typography>
                                $
                              </Typography>
                              <Box flexGrow={1} />
                              <Typography>
                                {(row?.costPerUnit)?.toFixed(2)}
                              </Typography>
                            </Stack>
                          </Stack>
                        </TableCell>
                        <TableCell
                          className="body-cell"
                          onClick={() => handleViewItemData(row)}
                        >
                          {row?.materialId?.categoryId?.categoryKhName}
                        </TableCell>
                        <TableCell
                          className="body-cell"
                          onClick={() => handleViewItemData(row)}
                        >
                          {row?.remark}
                        </TableCell>
                        <TableCell
                          className="body-cell"
                          align="right"
                          onClick={() => handleViewItemData(row)}
                        >
                          <Switch
                            size="small"
                            checked={row?.isUse}
                            onChange={(e) =>
                              handleUpdateStatus(row?._id, !row?.isUse)
                            }
                          />
                        </TableCell>
                        <TableCell className="body-cell action-cell">
                          <ListMaterialUnitAction
                            editData={row}
                            setRefetch={refetch}
                          />
                        </TableCell>
                      </TableRow>

                    </Fragment>
                  ))}
                </TableBody>
              )}
            </>
          )}
        </Table>
      </TableContainer>

      <ViewMeterialUnit
        editData={dataView}
        open={openView}
        handleClose={handleCloseView}
      />

    </Box>
  )
}